<div class="marriottCreateForm">
  <ng-container *ngIf="!showErrorSuccessBox; else errorSuccessBox">
    <p>{{'BOOKING_MODULE.MARRIOTT_BONVOY.CONFIRM_EMAIL' | transloco }}</p>
    <div class="marriottCreateForm__input">
      <app-form-text-input
        [form]="marriottCreateForm"
        [formControlSelector]="flyerSelector"
        [id]="flyerSelector"
        [maxLength]="50"
        [isSubmitted]="isSubmitted"
        [formInputType]="documentInput"
        [inputDocumentType]="alphanumericType"
        [label]="'EMAIL' | transloco"
        [placeholder]="'EMAIL' | transloco">
      </app-form-text-input>
    </div>
    <div class="marriottCreateForm__button">
      <app-ds-button
        [isLoading]="isLoadingMarriottCreateForm"
        [labels]="{ ButtonLabel: 'BOOKING_MODULE.MARRIOTT_BONVOY.CREATE_MARRIOTT_BONVOY_ACCOUNT' | transloco }"
        (clickEvent)="createAcount()">
      </app-ds-button>
    </div>
  </ng-container>
  <ng-template #errorSuccessBox>
    <div class="marriottCreateForm__errorSuccessBox">
      <ng-container *ngIf="isSuccessStatus; else errorStatus">
        <span class="marriottCreateForm__errorSuccessBox-icon success">
          <i aria-hidden="true" class="icon-check"></i>
        </span>
        <h4>{{'BOOKING_MODULE.MARRIOTT_BONVOY.SUCCESS_TITLE' | transloco}}</h4>
        <p>{{'BOOKING_MODULE.MARRIOTT_BONVOY.YOUR_NUMBER' | transloco}}</p>
        <h4>{{marriottCreatedAccount?.rewardsNumber}}</h4>
        <div class="marriottCreateForm__button">
          <app-ds-button
            [labels]="{ ButtonLabel: 'BOOKING_MODULE.MARRIOTT_BONVOY.SUCCESS_BUTTON' | transloco }"
            (clickEvent)="saveBonvoyNumber()">
          </app-ds-button>
        </div>
      </ng-container>

      <ng-template #errorStatus>
        <span class="marriottCreateForm__errorSuccessBox-icon error">
          <i aria-hidden="true" class="icon-close"></i>
        </span>
        <h4>{{'BOOKING_MODULE.MARRIOTT_BONVOY.ERROR_TITLE' | transloco}}</h4>
        <p>{{'BOOKING_MODULE.MARRIOTT_BONVOY.' + marriottCreateAccountShowStatus.messageCode | transloco}}</p>
        <div class="marriottCreateForm__button">
          <app-ds-button
            [labels]="{ ButtonLabel: 'BOOKING_MODULE.MARRIOTT_BONVOY.ERROR_BUTTON' | transloco }"
            (clickEvent)="resetForm()">
          </app-ds-button>
        </div>
      </ng-template>
    </div>


  </ng-template>
</div>